import { lazy } from 'react'

const Home = lazy(() => import('./Home'))

export default Home
